import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-featured-collections',
  templateUrl: './featured-collections.component.html',
  styleUrls: ['./featured-collections.component.scss']
})
export class FeaturedCollectionsComponent implements OnInit {
  slidesData: any = [];
  featuredData:any = [];

  constructor(private dataService: DataService,) { }

  async ngOnInit() {
    (await this.dataService.getFeaturedBannerService()).subscribe((singleservice) => {
      this.slidesData = [];
      this.slidesData = singleservice;
    });
    
    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        this.featuredData = [];

        this.featuredData = singleservice.filter((data)=>{
          return data["isFeatured"]
        })

        //console.log(this.featuredData);
      }
    );
  }

}
